export function numString(x){
    if(x === "one"){
        return "1";
    }else if(x === "two"){
        return "2";
    }else if(x === "three"){
        return "3";
    }else if(x === "four"){
        return "4";
    }else if(x === "five"){
        return "5";
    }else if(x === "six"){
        return "6";
    }else if(x === "seven"){
        return "7";
    }else if(x === "eight"){
        return "8";
    }else if(x === "nine"){
        return "9";
    }else if(x === "addHand"){
        return "+";
    }else if(x === "multiplyHand"){
        return "x";
    }else{
        return "error";
    }
}